import { render, staticRenderFns } from "./ChartBars.vue?vue&type=template&id=1b4ffb5c&scoped=true"
import script from "./ChartBars.vue?vue&type=script&lang=js"
export * from "./ChartBars.vue?vue&type=script&lang=js"
import style0 from "./ChartBars.vue?vue&type=style&index=0&id=1b4ffb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ffb5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VProgressLinear,VSheet})
